const variant = {
    'solid-primary': 'bg-primary border-primary text-white',
    'solid-sucess': 'bg-sucess border-sucess text-white',
    'solid-warning': 'bg-warning border-warning text-white',
    'solid-error': 'bg-error border-error text-white',
    'solid-black': 'bg-black border-black text-white',
    'solid-gray': 'bg-gray border-gray text-white',
    'solid-white': 'bg-white border !text-black ',
    'solid-blue': 'bg-blue border-blue text-white ',

    'soft-primary': 'bg-primary-100 text-primary-700',
    'soft-blue': 'bg-blue-100 text-blue-700',
    'soft-pink': 'bg-pink-100 text-pink-700',
    'soft-indigo': 'bg-indigo-100 text-indigo-700',

    'soft-sucess': 'bg-sucess-100 text-sucess-700',
    'soft-warning': 'bg-warning-100 text-warning-700',
    'soft-error': 'bg-error-100 text-error-700',
    'soft-black': 'bg-gray-100 text-gray-900',
    'soft-gray': 'bg-gray-100 text-gray-900',

    'outline-primary': 'text-primary border-primary border bg-transparent',
    'outline-sucess': 'text-sucess border-sucess border bg-transparent',
    'outline-warning': 'text-warning border-warning border bg-transparent',
    'outline-error': 'text-error border-error border bg-transparent',
    'outline-black': 'text-black border-black border bg-transparent',
    'outline-gray': 'text-gray border-gray border bg-transparent',
    'outline-white': 'text-black border-white border bg-transparent',

    'softborder-black': 'bg-gray-100 text-gray-900 border-black/10 border',
    'softborder-gray': 'bg-gray-50  text-gray-700 border-gray-100 border',
    'softborder-primary': 'bg-primary-50 text-primary-700 border-primary-100 border',
    'softborder-blue': 'bg-blue-50 text-blue-700 border-blue-100 border',

    'softborder-sucess': 'bg-sucess-50 text-sucess-700 border-sucess-100 border',
    'softborder-warning': 'bg-warning-50 text-warning-700 border-warning-100 border',
    'softborder-error': 'bg-error-50 text-error-700 border-error-100 border',
    'softborder-white': 'bg-white-50 text-white-700 border-white border',
};

export default variant;
